import React, { useState } from "react";
import { Checkbox, Tooltip } from "antd";
// import Count_cards from "../../../../../assets/chartIcons/Count_cards.svg";
// import Line_chart from "../../../../../assets/chartIcons/Line_chart.svg";
// import area_chart from "../../../../../assets/chartIcons/area_chart.svg";
// import Table from "../../../../../assets/chartIcons/Table.svg";
// import Bar_chart from "../../../../../assets/chartIcons/Bar_chart.svg";
// import speedometer_chart from "../../../../../assets/chartIcons/speedometer_chart.svg";

// import Line_chart from "../../../../../assets/chartIcons/Line_chart.svg";
// import area_chart from "../../../../../assets/chartIcons/area_chart.svg";
// import Table from "../../../../../assets/chartIcons/Table.svg";
// import Bar_chart from "../../../../../assets/chartIcons/Bar_chart.svg";
// import speedometer_chart from "../../../../../assets/chartIcons/speedometer_chart.svg";
// import Count_cards from "../../../../../assets/chartIcons/countIcon.svg";
// import verticalBar from "../../../../../assets/chartIcons/verticalBar.svg";
// import wordCloud from "../../../../../assets/chartIcons/area_chart.svg";
// import Bubble_Chart from "../../../../../assets/chartIcons/Bubble_Chart.svg";
// import heatmap from "../../../../../assets/chartIcons/heatmap.svg";
// import Sunburst_Icon from "../../../../../assets/chartIcons/Sunburst_Icon.svg";
import Syle_Two from "../../../../../assets/WidgetMaker/Syle_Two.svg";
import Syle_TwoBlue from "../../../../../assets/WidgetMaker/Syle_Two_blue.svg";
import Syle_oneBlue from "../../../../../assets/WidgetMaker/Style_One_blue.svg";
import Syle_one from "../../../../../assets/WidgetMaker/Style_One.svg";
import one_thirdBlue from "../../../../../assets/WidgetMaker/one-third-Blue.svg";
import one_third from "../../../../../assets/WidgetMaker/one-third.svg";
import two_thirdBlue from "../../../../../assets/WidgetMaker/two_thirdBlue.svg";
import two_third from "../../../../../assets/WidgetMaker/two_third.svg";

import Datetime from "../../../../layout/DateTime";
import { getPaneIndex } from "../../../../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
//import Brand from "../../../../layout/WelcomePage/Template/Brand";
import { setUpdateGraphType } from "../../../../../redux/actions/dashboard/Tab1";
import BrandsLogicalGroup from "../../../../layout/WelcomePage/Template/BrandsLogicalGroup";
import { setWidgetSpan } from "../../../../../redux/actions/section/section";
//import { setIsWidgetEdit } from "../../../../../redux/actions/Filter";
import { memo } from "react";
import ProfileFilter from "../../../../layout/WelcomePage/Template/ProfileFilter";
import { useEffect } from "react";
import { setCompetitorBrandType } from "../../../../../redux/actions/Template";
import PlannedValueField from "./PlannedValueField";

const General = ({ setColumnSpan, selectedSection, widget_metadata }) => {
  const dispatch = useDispatch();
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);

  const Section = useSelector((state) => state.Section.addSection);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const competitorBrandType = useSelector(
    (state) => state?.Template?.competitorBrandType
  ); //add in templte section
  // const [activeTab, setActiveTab] = useState(
  // 	graph_type === "aggregate" ? "verticalbar" : graph_type
  // );
  const spans = Section[editPanelInfo?.section_index]?.data[
    editPanelInfo?.widget_index
  ]?.span
    ? Section[editPanelInfo?.section_index]?.data[editPanelInfo?.widget_index]
        ?.span
    : "full";
  //const [activeTab, setActiveTab] = useState("aggregate");
  const [spanActiveTab, setSpanActiveTab] = useState(spans);
  const [competitionFilterType, setCompetitionFilterType] = useState({
    parentType: false,
    competitionType: false,
    isDisabled: false,
    isVisible: false,
    type: "initial",
  });
  let index = getPaneIndex(panes, activeKey);
  let pathName = window.location.pathname?.split("/")?.[1];
  let quick_filter_name = shareTemplateData
    ? shareTemplateData?.quick_filter?.attribute
    : pathName === "edit-dashboard" || pathName === "create-dashboard"
    ? templateDetails?.quick_filter
    : panes?.[index]?.quick_filter;

  const handleCharts = (e) => {
    let index = getPaneIndex(panes, activeKey);
    let obj = {
      value: e,
      index: index,
      panes: panes,
      section_index: editPanelInfo?.section_index,
      widget_index: editPanelInfo?.widget_index,
    };
    dispatch(setUpdateGraphType(obj));
    //setActiveTab(e);
  };
  const handleSpanSize = (span) => {
    setSpanActiveTab(span);
    let templateObj = {
      section: Section,
      templateDetails: templateDetails,
      section_index: editPanelInfo?.section_index,
      authParams: authParams,
      widget_index: editPanelInfo?.widget_index,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      duration: templateDetails?.templateDuration,
      span: span,
    };
    dispatch(setWidgetSpan(templateObj));
  };
  const handleParentAndCompetitionBrandChange = (e) => {
    let updatedCompetitionFilterType = { ...competitionFilterType };
    let pType = updatedCompetitionFilterType?.parentType;
    let cType = updatedCompetitionFilterType?.competitionType;
    if (e?.target?.value === "Parent") {
      if (e?.target?.checked || (!e?.target?.checked && cType)) {
        pType = !pType;
      } else {
        cType = !cType;
        pType = !pType;
      }
    } else if (e?.target?.value === "Competition") {
      if (e?.target?.checked || (!e?.target?.checked && pType)) {
        cType = !cType;
      } else {
        pType = !pType;
        cType = !cType;
      }
    }
    updatedCompetitionFilterType = {
      ...updatedCompetitionFilterType,
      parentType: pType,
      competitionType: cType,
      type:
        pType && cType ? null : pType ? "Parent" : cType ? "Competition" : null,
    };
    setCompetitionFilterType({ ...updatedCompetitionFilterType });
    dispatch(setCompetitorBrandType(updatedCompetitionFilterType?.type));
  };
  useEffect(() => {
    //this is to reset Parent And Competition Brand Filter according to types
    resetParentAndCompetitionBrand();
  }, [selectedSection, templateDetails]);
  const resetParentAndCompetitionBrand = () => {
    if (selectedSection?.type === "template_section") {
      let updatedCompetitionFilterType = { ...competitionFilterType };
      let template_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;
      let comBrand = template_brands?.columns?.[0]?.competitor
        ? template_brands?.columns?.[0]
        : template_brands?.[0]?.competitor
        ? template_brands?.[0]
        : template_brands?.competitor
        ? template_brands
        : null;
      if (comBrand?.competitor) {
        // show ParentAndCompetitionBrand type options
        updatedCompetitionFilterType = {
          ...updatedCompetitionFilterType,
          isVisible: true,
        };
        let currectSection =
          editPanelInfo &&
          Section &&
          editPanelInfo?.type === "template_section" &&
          editPanelInfo?.section_index >= 0 &&
          Section?.[editPanelInfo?.section_index];
        let secLockedOnBrand =
          selectedSection?.is_locked &&
          currectSection?.brands?.length > 0 &&
          (currectSection?.brands?.[0]?.columns
            ? !currectSection?.brands?.[0]?.columns?.[0]?.competitor
            : !currectSection?.brands?.[0]?.competitor);
        if (secLockedOnBrand) {
          // disabled ParentAndCompetitionBrand type options
          updatedCompetitionFilterType = {
            ...updatedCompetitionFilterType,
            isDisabled: true,
          };
        } else {
          // enabled ParentAndCompetitionBrand type options
          updatedCompetitionFilterType = {
            ...updatedCompetitionFilterType,
            isDisabled: false,
          };
          if (competitorBrandType === "initial") {
            if (
              currectSection?.comp_brand_type === false ||
              currectSection?.comp_brand_type === true
            ) {
              updatedCompetitionFilterType = {
                ...updatedCompetitionFilterType,
                parentType: currectSection?.comp_brand_type === false,
                competitionType: currectSection?.comp_brand_type === true,
                type:
                  currectSection?.comp_brand_type === false
                    ? "Parent"
                    : currectSection?.comp_brand_type === true
                    ? "Competition"
                    : null,
              };
            } else {
              // if comp_brand_type key is not present that means by default explode functionality applicable on this flow
              updatedCompetitionFilterType = {
                ...updatedCompetitionFilterType,
                parentType: true,
                competitionType: true,
                type: null,
              };
            }
          } else {
            updatedCompetitionFilterType = {
              ...updatedCompetitionFilterType,
              parentType:
                competitorBrandType === "Parent" || competitorBrandType === null
                  ? true
                  : false,
              competitionType:
                competitorBrandType === "Competition" ||
                competitorBrandType === null
                  ? true
                  : false,
              type: competitorBrandType,
            };
          }
        }
      } else {
        // hide ParentAndCompetitionBrand type options
        updatedCompetitionFilterType = {
          ...updatedCompetitionFilterType,
          isVisible: false,
        };
      }
      setCompetitionFilterType({ ...updatedCompetitionFilterType });
      dispatch(setCompetitorBrandType(updatedCompetitionFilterType?.type));
    }
  };
  return (
    <div
      className="custom_scroll"
      style={{
        height: "calc(100vh - 15rem)",
        overflow: "auto",
        marginRight: "0.5rem",
        paddingRight: "0.5rem",
      }}
    >
      {window.location.pathname !== "/dashboard" &&
      widget_metadata?.type === "predefined" &&
      !widget_metadata?.supported_filters?.length ? (
        ""
      ) : (
        <>
          <div className="mt-3 floating-label-group header-brands analytics_brand">
            {/* <Brand
						type={
							editPanelInfo?.type === "dashboard_section"
								? "dashboard_section"
								: editPanelInfo?.type === "dashboard_widget"
								? "dashboard_widget"
								: editPanelInfo?.type === "template_section"
								? "template_section"
								: editPanelInfo?.type === "template_widget" && "template_widget"
						}
					/> */}
            <BrandsLogicalGroup
              type={
                editPanelInfo?.type === "dashboard_section"
                  ? "dashboard_section"
                  : editPanelInfo?.type === "dashboard_widget"
                  ? "dashboard_widget"
                  : editPanelInfo?.type === "template_section"
                  ? "template_section"
                  : editPanelInfo?.type === "template_widget" &&
                    "template_widget"
              }
            />
            <label
              className="portlet-label floating-label mr-15"
              style={{
                backgroundColor: "#fff",
                top: "-0.8rem",
                fontSize: "1.2rem",
              }}
            >
              Brand
            </label>
          </div>

          <div className="mt-3">
            <Datetime
              type={
                editPanelInfo?.type === "dashboard_section"
                  ? "dashboard_section"
                  : editPanelInfo?.type === "dashboard_widget"
                  ? "dashboard_widget"
                  : editPanelInfo?.type === "template_section"
                  ? "template_section"
                  : editPanelInfo?.type === "template_widget" &&
                    "template_widget"
              }
            />
          </div>

          {/* Plan Vs Delivered Input field Component */}
          {(selectedSection?.type === "widgetFilter" ||
            selectedSection?.type === "template_widget") &&
            widget_metadata?.x_axis?.attribute === "Plan_Delivered" &&
            widget_metadata?.chart?.chart_settings?.planned_val >= 0 && (
              <div className="mt-3 floating-label-group header-brands analytics_brand">
                <PlannedValueField
                  widgetData={widget_metadata}
                  type={
                    editPanelInfo?.type === "dashboard_widget"
                      ? "dashboard_widget"
                      : editPanelInfo?.type === "template_widget" &&
                        "template_widget"
                  }
                />
                <label
                  className="portlet-label floating-label mr-15"
                  style={{
                    backgroundColor: "#fff",
                    top: "-0.8rem",
                    fontSize: "1.2rem",
                  }}
                >
                  Planned Value
                </label>
              </div>
            )}

          {/* Profile Filter New Development */}
          {quick_filter_name !== "AccountID" &&
            (selectedSection?.type === "widgetFilter" ||
              selectedSection?.type === "template_widget") &&
            widget_metadata?.profile_filters_flag && (
              <div className="mt-3 floating-label-group header-brands analytics_brand">
                <ProfileFilter
                  type={
                    editPanelInfo?.type === "dashboard_section"
                      ? "dashboard_section"
                      : editPanelInfo?.type === "dashboard_widget"
                      ? "dashboard_widget"
                      : editPanelInfo?.type === "template_section"
                      ? "template_section"
                      : editPanelInfo?.type === "template_widget" &&
                        "template_widget"
                  }
                />
                <label
                  className="portlet-label floating-label mr-15"
                  style={{
                    backgroundColor: "#fff",
                    top: "-0.8rem",
                    fontSize: "1.2rem",
                  }}
                >
                  Profile Filter
                </label>
              </div>
            )}
          {selectedSection?.type === "template_section" &&
            competitionFilterType?.isVisible && (
              <div className="mt-3">
                <div className="font-weight600 mb-15 line-height-normal text_heading text-transform__capitalize">
                  Filter Brand / Show Brand
                  <Tooltip
                    title={
                      competitionFilterType.isDisabled
                        ? "The section should not be locked on brand"
                        : "This is applicable on competitor brand, and it is applied when you click on Apply Button"
                    }
                  >
                    <i
                      className="fa fa-info-circle cursor-pointer ml-1"
                      style={{ color: "#869dad" }}
                    />
                  </Tooltip>
                </div>
                <Checkbox
                  disabled={competitionFilterType?.isDisabled}
                  value="Parent"
                  className="text_regular d-block m-0 mb-2 line-height-normal d-flex align-items-start "
                  onChange={handleParentAndCompetitionBrandChange}
                  checked={competitionFilterType?.parentType}
                >
                  Owned Brand
                </Checkbox>
                <Checkbox
                  disabled={competitionFilterType?.isDisabled}
                  value="Competition"
                  className="text_regular d-block m-0 mb-2 line-height-normal d-flex align-items-start "
                  onChange={handleParentAndCompetitionBrandChange}
                  checked={competitionFilterType?.competitionType}
                >
                  Competition Brand
                </Checkbox>
              </div>
            )}

          {/* {(selectedSection?.type === "widgetFilter" ||
        selectedSection?.type === "template_widget") && 
        widget_metadata?.profile_filters_flag &&
        (widget_metadata?.is_locked || selectedSection?.is_locked) && 
        <>
        <div className="mt-15">Widget is locked</div>
        </>
      } */}
        </>
      )}

      {editPanelInfo?.type === "template_widget" && (
        <div>
          <div className="text-Darkgray mt-15 mb-15 font-weight500">
            Widget Size
          </div>
          <div className="d-flex align-items-center">
            <span
              className="mr-15 rectangle_full cursor-pointer"
              onClick={() => handleSpanSize("full")}
            >
              <img
                src={spanActiveTab === "full" ? Syle_oneBlue : Syle_one}
                alt="Syle_one"
              />
            </span>
            <Tooltip
              title={
                (Section[editPanelInfo?.section_index]?.data[
                  editPanelInfo?.widget_index
                ]?.graph_type ||
                  Section[editPanelInfo?.section_index]?.data[
                    editPanelInfo?.widget_index
                  ]?.chart?.chart_type) === "bubble"
                  ? "" // for bubble chart enabling this feature now
                  : ""
              }
            >
              <span className="cursor-pointer rectangle_half mr-15">
                <img
                  src={
                    spanActiveTab === "two_third" ? two_thirdBlue : two_third
                  }
                  alt="two_third"
                  style={{ minHeight: "2.8rem" }}
                  onClick={() => handleSpanSize("two_third")}
                  className={
                    (Section[editPanelInfo?.section_index]?.data[
                      editPanelInfo?.widget_index
                    ]?.graph_type ||
                      Section[editPanelInfo?.section_index]?.data[
                        editPanelInfo?.widget_index
                      ]?.chart?.chart_type) === "bubble"
                      ? "" // for bubble chart enabling this feature now
                      : ""
                  }
                />
              </span>
            </Tooltip>
            <Tooltip
              title={
                (Section[editPanelInfo?.section_index]?.data[
                  editPanelInfo?.widget_index
                ]?.graph_type ||
                  Section[editPanelInfo?.section_index]?.data[
                    editPanelInfo?.widget_index
                  ]?.chart?.chart_type) === "bubble"
                  ? "" // for bubble chart enabling this feature now
                  : ""
              }
            >
              <span className="cursor-pointer rectangle_half">
                <img
                  src={spanActiveTab === "half" ? Syle_TwoBlue : Syle_Two}
                  alt="Syle_Two"
                  onClick={() => handleSpanSize("half")}
                  className={
                    (Section[editPanelInfo?.section_index]?.data[
                      editPanelInfo?.widget_index
                    ]?.graph_type ||
                      Section[editPanelInfo?.section_index]?.data[
                        editPanelInfo?.widget_index
                      ]?.chart?.chart_type) === "bubble"
                      ? "" // for bubble chart enabling this feature now
                      : ""
                  }
                />
              </span>
            </Tooltip>
            <Tooltip
              title={
                (Section[editPanelInfo?.section_index]?.data[
                  editPanelInfo?.widget_index
                ]?.graph_type ||
                  Section[editPanelInfo?.section_index]?.data[
                    editPanelInfo?.widget_index
                  ]?.chart?.chart_type) === "bubble"
                  ? "" // for bubble chart enabling this feature now
                  : ""
              }
            >
              <span className="cursor-pointer rectangle_half ml-15">
                <img
                  src={
                    spanActiveTab === "one_third" ? one_thirdBlue : one_third
                  }
                  alt="one_third"
                  style={{ minHeight: "2.8rem" }}
                  onClick={() => handleSpanSize("one_third")}
                  className={
                    (Section[editPanelInfo?.section_index]?.data[
                      editPanelInfo?.widget_index
                    ]?.graph_type ||
                      Section[editPanelInfo?.section_index]?.data[
                        editPanelInfo?.widget_index
                      ]?.chart?.chart_type) === "bubble"
                      ? "" // for bubble chart enabling this feature now
                      : ""
                  }
                />
              </span>
            </Tooltip>
          </div>
        </div>
      )}
      {/* <div className="text-Darkgray mt-15 mb-15 font-weight500">
					Chart Type
				</div>
				<div 
				  className="ChartType mb-15 mr-15"
				  style={{justifyContent: editPanelInfo?.widget_index === 0 && 'initial'}}
				>
					{
						panes?.template_name === "aggregate" ? (<>
							<img
								src={Count_cards}
								alt="Count chart"
								className="mr-2 ChartType-list active"
							/>
							<div
								style={{
									width: "0.1rem",
									height: "2.6rem",
									borderLeft: "0.1rem #ddd dashed",
								}}
							/>
							<img src={verticalBar} 
								alt="vertical Bar chart"
								className={`mr-2 ml-2 ChartType-list ${activeTab === 'verticalbar' && 'active'}`}
								onClick={()=> handleCharts('verticalbar')}
							/>
							<img src={Table} 
								alt="Table chart"
								className={`mr-1 ChartType-list ${activeTab === 'table' && 'active'}`}
								onClick={()=> handleCharts('table')}
							/>
						</>) : (<>
							<img
						src={Line_chart}
						alt="area chart"
						className={`mr-1 ChartType-list ${activeTab === 'line' && 'active'}`}
						onClick={()=> handleCharts('line')}
					/>
					<img
						src={area_chart}
						alt="area chart"
						className={`mr-1 ChartType-list ${activeTab === 'area' && 'active'}`}
						onClick={()=> handleCharts('area')}
					/>
					<img src={Table} 
					 alt="Table chart"
					 className={`mr-1 ChartType-list ${activeTab === 'table' && 'active'}`}
					 onClick={()=> handleCharts('table')}
				  />
					<img
						src={Bar_chart}
						alt="Bar chart"
						className={`mr-1 ChartType-list ${activeTab === 'bar' && 'active'}`}
						onClick={()=> handleCharts('bar')}
					/>
					<img
						src={speedometer_chart}
						alt="Pie chart"
						className={`mr-1 ChartType-list ${activeTab === 'pie' && 'active'}`}
						onClick={()=> handleCharts('pie')}
					/>
					</>)
					}
				</div> */}
    </div>
  );
};

export default memo(General);
